import { Component } from '@verndale/core';
import { google, outlook, yahoo, ics } from 'calendar-link';

class ShareCard extends Component {
  eventTitle: string;
  eventStart: string;
  eventEnd: string;
  allDay: boolean;
  eventDescription: string;
  eventLocation: string;

  constructor(el: HTMLElement) {
    super(el);
    this.eventTitle = this.el.dataset.eventTitle || '';
    this.eventStart = this.el.dataset.eventStart || '';
    this.eventEnd = this.el.dataset.eventEnd || '';
    this.eventDescription = this.el.dataset.eventDescription || '';
    this.eventLocation = this.el.dataset.eventLocation || '';
    this.allDay = this.el.dataset.allDay === 'true' || false;
    this.generateDynamicLinks();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      addToCalendarBtn: this.el.querySelector<HTMLElement>('.share-event__card-btn'),
      sharePopover: this.el.querySelector<HTMLElement>('.calendar-popover'),
      calendarLinks: this.el.querySelectorAll<HTMLElement>('.btn-calendar')
    };
  }

  addListeners() {
    (this.dom.addToCalendarBtn as HTMLElement).addEventListener(
      'click',
      this.togglePopover.bind(this)
    );
    document.addEventListener('click', this.closePopover.bind(this));
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  generateDynamicLinks() {
    (this.dom.calendarLinks as NodeList).forEach(link => {
      const provider = (link as HTMLElement).dataset.provider || '';
      (link as HTMLAnchorElement).href = this.generateCalendarLink(provider);
    });
  }

  generateCalendarLink(provider: string) {
    const event = {
      title: this.eventTitle,
      start: this.eventStart,
      end: this.eventEnd,
      allDay: this.allDay,
      description: this.eventDescription,
      location: this.eventLocation
    };

    switch (provider) {
      case 'google':
        return google(event);
      case 'outlook':
        return outlook(event);
      case 'yahoo':
        return yahoo(event);
      case 'ics':
        return ics(event);
      default:
        return '';
    }
  }

  togglePopover(e: Event) {
    const isExpanded = (e.target as HTMLElement).getAttribute('aria-expanded') === 'true' || false;
    (e.target as HTMLElement).setAttribute('aria-expanded', `${!isExpanded}`);
    (this.dom.sharePopover as HTMLElement).classList.toggle('is-visible');
    (this.dom.sharePopover as HTMLElement).setAttribute('aria-hidden', String(!isExpanded));
  }

  closePopover(e: Event) {
    const target = e.target as HTMLElement;
    if (
      !(this.dom.addToCalendarBtn as HTMLElement).contains(target) &&
      !(this.dom.sharePopover as HTMLElement).contains(target)
    ) {
      (this.dom.addToCalendarBtn as HTMLElement).setAttribute('aria-expanded', 'false');
      (this.dom.sharePopover as HTMLElement).classList.remove('is-visible');
      (this.dom.sharePopover as HTMLElement).setAttribute('aria-hidden', 'true');
    }
  }

  handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      (this.dom.addToCalendarBtn as HTMLElement).setAttribute('aria-expanded', 'false');
      (this.dom.sharePopover as HTMLElement).classList.remove('is-visible');
      (this.dom.sharePopover as HTMLElement).setAttribute('aria-hidden', 'true');
    }
  }
}

export default ShareCard;
